import axios from 'axios'

class SiteConfigService {
  constructor() {
    this.config = null
    // 使用相对路径，通过代理转发
    this.apiBaseUrl = process.env.NODE_ENV === 'production' 
      ? (process.env.VUE_APP_API_BASE_URL || '/api') 
      : '/api'
  }

  // 获取前端配置
  async getFrontendConfigs() {
    try {
      const response = await axios.get(`${this.apiBaseUrl}/site-config/frontend`)
      if (response.data.success) {
        this.config = response.data.data
        return this.config
      }
      return null
    } catch (error) {
      console.error('获取网站配置失败:', error)
      return null
    }
  }

  // 获取配置值
  getConfig(key) {
    return this.config ? this.config[key] : null
  }

  // 获取网站名称
  getSiteName() {
    return this.getConfig('site_name') || '影视资源搜索'
  }

  // 获取网站Logo
  getSiteLogo() {
    return this.getConfig('site_logo') || ''
  }

  // 获取页脚文本
  getFooterText() {
    return this.getConfig('footer_text') || ''
  }

  // 获取交流群图片
  getContactGroupImage() {
    return this.getConfig('contact_group_image') || ''
  }

  // 获取资源文档链接
  getResourceDocsUrl() {
    return this.getConfig('resource_docs_url') || ''
  }

  // 获取完整Logo路径
  getFullLogoPath() {
    const logo = this.getSiteLogo()
    if (!logo) return ''
    // 直接返回后端提供的完整URL，无需前端拼接
    return logo
  }

  // 获取完整交流群图片路径
  getFullContactGroupImagePath() {
    const image = this.getContactGroupImage()
    if (!image) return ''
    // 直接返回后端提供的完整URL，无需前端拼接
    return image
  }
}

export default new SiteConfigService()